<div class="loader">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>